export default __webpack_public_path__ + "static/media/ww5.4c470a2e.jpg";